import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { BaseRouteComponent } from '../../shared/base-route.component';

@Component({
    selector: 'app-import-civic',
    templateUrl: './import-civic.component.html',
    styleUrls: ['./import-civic.component.css', '../blog.css'],
})
export class ImportCivicComponent extends BaseRouteComponent {
    amazonUrl = `https://www.amazon.com/VESAFE-Monitoring-Universal-Full-Color-Waterproof/dp/B09GXJ1L3H?ref_=ast_sto_dp&th=1&psc=1`;

    constructor(route: ActivatedRoute, app: AppComponent) {
        super(route, app);
    }
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/import-civic/import-civic.component.ts